import React, {memo} from 'react'

import {resolveHelpURL} from '../../../../../../utils/url'
import HelpLink from '../../../../../common/HelpLink/HelpLink'
import IconButton from '../../../../../common/IconButton/IconButton'

function ConfigurationDescriptionComponent() {
  return (
    <>
      {
        'Values and settings that can be shared across different build configurations. Configuration parameters are not used by runners in their building routines.'
      }
      <HelpLink
        url={resolveHelpURL('configuring-build-parameters.html#Configuration+Parameters')}
        Component={IconButton}
        icon="help"
        preservePlus
      />
    </>
  )
}

export const ConfigurationDescription = memo(ConfigurationDescriptionComponent)
